<template>
  <div class="background-image" id="app">
    <el-container v-if="!isLogin">
      <div class="login-container" v-loading="loginLoading">
        <div class="login-title">{{ this.GLOBAL.proName }}</div>
        <el-form ref="loginForm" :model="loginData" :rules="loginRules" label-position="left" label-width="80px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="loginData.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input @keyup.enter.native="submitLogin" type="password" v-model="loginData.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-button style="background-color: #409EFF;border-color: #409EFF;" class="login-button" type="primary" @click="submitLogin">登录</el-button>
        </el-form>
      </div>
    </el-container>
    <el-container v-if="isLogin">
      <el-header height="70px"><Header></Header></el-header>
      <el-container>
        <el-aside :width="controlAside.elAsideWidth">
          <Aside :sidebarItems="sidebarItemVal()" :currentIndex="'1'" @toggleAside="toggleAside"></Aside>
        </el-aside>
        <el-main :style="controlAside.elMainWidth">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from '@/components/frame/Header.vue'
import Aside from '@/components/frame/Aside.vue'
const md5 = require('@/../static/plugins/md5.js')
import DevicePixelRatio from '@/../static/plugins/devicePixelRatio.js'

export default {
  name: 'App',
  components: {Header, Aside},
  data () {
    return {
      sidebarItem: [],
      sidebarMchItem: [
        { index: '1', path: '/', text: '首页', icon: 'el-icon-s-home', trees: [], role_btn:''},
        // { index: '1-1', path: '/admin', text: '账号管理', icon: 'el-icon-s-custom', trees: [], role_btn:''},
        // { index: '1-2', path: '/ask', text: '咨询管理', icon: 'el-icon-s-comment', trees: [], role_btn:''},
        { title: true, text: '内容管理' },
        {
          index: '1-3',
          path: '#',
          text: '新闻中心',
          icon: 'el-icon-date',
          trees: [
            { index: '1-3-1', path: '/info', text: '企业动态管理' },
            { index: '1-3-2', path: '/news', text: '行业新闻管理' },
            { index: '1-3-3', path: '/notificatio', text: '媒体报道管理' },
          ]
        },
        { index: '1-4', path: '/courtship', text: '招商合作', icon: 'el-icon-headset', trees: [], role_btn:''},
        { index: '1-5', path: '/upAndDow', text: '下载资料上传', icon: 'el-icon-paperclip', trees: [], role_btn:''},
        
        
        { title: true, text: '页面管理:' },
        { index: '1-14', path: '/businessType', text: 'Banner图管理', icon: 'el-icon-s-grid', trees: [], role_btn:''},
        { index: '1-9', path: '/banners', text: '广告位管理', icon: 'el-icon-picture', trees: [], role_btn:''},
        { index: '1-8', path: '/policy', text: '关于我们', icon: 'el-icon-s-check', trees: [], role_btn:''},
        { index: '1-10', path: '/servers', text: '业务板块管理', icon: 'el-icon-hot-water', trees: [], role_btn:''},
        { index: '1-15', path: '/xcm', text: '小程序码管理', icon: 'el-icon-full-screen', trees: [], role_btn:''},

      ],
      sidebarOutItem:[
      { title: true, text: '信息管理' },
        { index: '2-1', path: '/banner', text: '轮播图', icon: 'el-icon-picture', trees: [] },
        { index: '2-3', path: '/categories', text: '分类管理', icon: 'el-icon-s-grid', trees: [] },
        { title: true, text: '商品管理' },
        { index: '2-4', path: '/goods', text: '商品', icon: 'el-icon-s-goods', trees: [] },
        { index: '2-5', path: '/records', text: '备案信息', icon: 'el-icon-s-ticket', trees: [] },
        { title: true, text: '订单' },
        {
          index: '2',
          path: '#',
          text: '订单管理',
          icon: 'el-icon-s-order',
          trees: [
            { index: '2-2-1', path: '/order', text: '全部订单' },
            { index: '2-2-2', path: '/ordersUnpaid', text: '待付款' },
            { index: '2-2-3', path: '/ordersNoCustomhouse', text: '待清关' },
            { index: '2-2-4', path: '/ordersYesCustomhouse', text: '已清关' },
            { index: '2-2-5', path: '/OrdersWaitingCross', text: '待发货' },
            { index: '2-2-6', path: '/ordersSend', text: '已发货' }
          ]
        },
        { title: true, text: '用户' },
        { index: '3', path: '/users', text: '用户管理', icon: 'el-icon-user-solid', trees: [] },
        { index: '13', path: '/Settled', text: '商家入驻', icon: 'el-icon-user-solid', trees: [] },
        // { title: true, text: '系统管理' },
        // { index: '14', path: '/branches', text: '管理员', icon: 'el-icon-s-shop', trees: [] },
      ],
      isCut: false,
      isLogin: false,
      loginData: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
      },
      loginLoading: false,
      controlAside: {
        elAsideWidth: '180px',
        elMainWidth: 'width: calc(100% - 180px); left: 180px;'
      }
    }
  },
  methods: {
    /**
     * 收展侧边栏
     */
    toggleAside: function (controlCollapse) {
      var that = this
      var currentWidth = controlCollapse ? '85px' : '180px'
      that.controlAside = {
        elAsideWidth: currentWidth,
        elMainWidth: 'width: calc(100% - ' + currentWidth + '); left: ' + currentWidth
      }
    },
    /**
     * 登录
     */
    submitLogin () {
      let that = this
      that.loginLoading = true
      let loginData = that.loginData
      that.$refs['loginForm'].validate(valid => {
        if (!valid) return ''
        that.SERVER.request({
          url: 'admin.php',
          method: 'POST',
          data: {
            controller: 'login',
            data: {
              username: loginData.username,
              password: md5.hexMD5(loginData.password)
            }
          },
          success: function (res) {
            if (res.data.status === 200) {
              that.COOKIE.setCookie('uid', "123", 7)
              that.COOKIE.setCookie('token', "123", 7)
              that.COOKIE.setCookie('log_name', "管理员", 7)
              // that.COOKIE.setCookie('uid', res.data.data._id, 7)
              // that.COOKIE.setCookie('log_name', res.data.data.username, 7)
              // that.COOKIE.setCookie('token', res.data.data.token, 7)
              // that.COOKIE.setCookie('log_username', res.data.data.username, 7)
              // 角色权限
              // that.sidebarItem = res.data.data.sidebarItem
              that.isLogin = true
              that.loginLoading = false
            } else {
              that.$message.error(res.data.errmsg)
              that.loginLoading = false
            }
          },
          error: function (errMsg) {
            that.loginLoading = false
            that.boundErrorMessages(errMsg)
          }
        })
      
      })
    },
    /**
     * 验证 uid
     */
    verifyLogin () {
      let that = this
      let uid = that.COOKIE.getCookie('uid')
      if (uid !== '') {
        that.isLogin = true
      } else {
        that.isLogin = false
      }
    },
    sidebarItemVal() {
      let that = this
      let isCut = that.COOKIE.getCookie('isCut')
      if ('sidebarOutItem' === isCut){
        that.COOKIE.setCookie('isCut', "sidebarOutItem", 7)
        console.log(isCut)
        return that.sidebarOutItem
      }else{
        that.COOKIE.setCookie('isCut', "sidebarMchItem", 7)
        console.log(isCut)
        return that.sidebarMchItem
      }
    }
  },
  mounted () {
    // 禁用屏幕放大
    DevicePixelRatio.init(1)
    // 验证密码
    this.verifyLogin()
    // 全局变量
    //设置游览器标题
    document.title = this.GLOBAL.proName //"新民市跨境进出口供应链平台"
    
    // Vue.directive({
    //     inserted: function(el,binding){
    //         document.title = el.dataset.title
    //     }
    // })

  }
}
</script>

<style scoped>
/* html,body{
  height: 100%;
  width: 100%;
  bottom: 0;
} */
.el-container {
  background-image: url('/static/img/background_img.png');/*设置背景图片*/
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  bottom: 0;
  position : absolute;
}
/* 页面主体样式 */
.el-header {
  background-color: #363636;
  border-bottom: 2px solid #494949;
  box-shadow: 0px 0px 10px #707070;
  width: 100%;
  height: 70px;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.el-aside {
  background: #f1f1f1;
  height: calc(100% - 70px);
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  left: 0;
  top: 70px;
  z-index: 10;
}
.el-main {
  background-color: #fff;
  min-height: calc(100% - 70px);
  width: calc(100% - 200px);
  position: absolute;
  left: 200px;
  top: 70px;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
.login-container {
  padding: 35px 50px;
  background-color: #fff;
  border-radius: 20px; 
  height: 260px;
  margin: 0 auto;
  margin-top: 28vh;
  margin-bottom: 36vh;
}
.login-container .el-form {
  width: 350px;
}
.login-title {
  color: #343A40;
  font-size: 25px;
  font-weight: 100;
  letter-spacing: 2px;
  margin-bottom: 40px;
  width: 100%;
  text-align: center;
}
.login-button {
  width: 100%;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue